module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACASURBVCiRjdGxDcIwEEbhE0rJAAyQAdiJhjGQoKOgTZdBMgCDpKShT/HRWCI4WPZrTrL8fOf/IiICPWbcowVMvjxahMUvl9LdXarv7LyrdRjXz7eMdMxGOrdIw0pYcEKHG67/hD2eymzTw6EibfeUOg0FYa4FMeKV/jShr4aR8wFD2eWYa7VkpQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 1